module.exports = __webpack_public_path__ + "img/fruit-watermelon-350x184.052cb475.jpg";